import React from 'react';
import Button from '@mui/material/Button';
import {useTranslation} from "react-i18next";
import {styled} from "@mui/material/styles";


export const ActionButton = styled(Button)(({theme, color}) => ({
    borderRadius: '25px',
    height: '32px',
    paddingLeft: '25px',
    paddingRight: '25px',
    fontWeight: 600,
    textTransform: 'none',
    color: 'white',
    marginLeft: '10px',
    backgroundColor: '#00E162',
    '&:hover': {
        backgroundColor: '#3D9A4A',
    },
}));

interface Props {
    onClick: () => void;
}

const GenerateImageButton: React.FC<Props> = ({onClick}) => {
    const {t} = useTranslation()

    return (
            <ActionButton
                onClick={onClick}
            >
                {t("editor.buttons.preparingFileForShare")}
            </ActionButton>
    );
};

export default GenerateImageButton;
